import { render, staticRenderFns } from "./MapboxMapResults.vue?vue&type=template&id=0a9f6cf6"
import script from "./MapboxMapResults.vue?vue&type=script&lang=js"
export * from "./MapboxMapResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,SortHotels: require('/vercel/path0/components/partials/SortHotels.vue').default,FilterHotels: require('/vercel/path0/components/partials/FilterHotels.vue').default,HotelResult: require('/vercel/path0/components/cards/HotelResult.vue').default,TheHeader: require('/vercel/path0/components/TheHeader.vue').default})
